import React from 'react';
import institutionalInvestorsLogo from './assets/institutionalInvestors.svg';
import dealersAndArrangersLogo from './assets/dealersAndArrangers.svg';
import corporateIssuersLogo from './assets/corporateIssuers.svg';

export const tabsMapping = [
  {
    label: 'Institutional Investors',
    value: 'institutionalInvestors',
  },
  {
    label: 'Dealers & Arrangers',
    value: 'dealersAndArrangers',
  },
  {
    label: 'Corporate Issuers',
    value: 'corporateIssuers',
  },
];

export const defaultTab = 'institutionalInvestors';

export const tabsContent = {
  institutionalInvestors: {
    title: 'Institutional Investors',
    logo: institutionalInvestorsLogo.src,
    benefits: [
      {
        key: 'streamlineAccess',
        title: 'Streamline access',
        description: (
          <>
            <span>InvestorSet</span> enables broader access to deal documentation for your back office without lengthy
            approval processes or expensive subscriptions. All onboarded issuers approve an investor whitelist
            that enables instant approval for most institutional investors and their firm.
          </>
        ),
      },
      {
        key: 'tradeFaster',
        title: 'Trade faster',
        description: (
          <>
            <span>InvestorSet</span> enables you to instantly access the documentation you need to trade in and
            out of securities.
          </>
        ),
      },
      {
        key: 'stayApprised',
        title: 'Stay apprised',
        description: (
          <>
            <span>InvestorSet</span> offers customizable email upload notifications at the deal level and
            supports programmatic access for automated downloading.
          </>
        ),
      },
    ],
  },
  dealersAndArrangers: {
    title: 'Dealers & Arrangers',
    logo: dealersAndArrangersLogo.src,
    benefits: [
      {
        key: 'tradeFaster',
        title: 'Trade faster',
        description: (
          <>
            <span>InvestorSet</span> enables timely access to the latest deal documents needed to effect a trade.
            What took a week can now take minutes for your sales team, traders and most institutional investors.
            Direct them to us.
          </>
        ),
      },
      {
        key: 'improveTargeting',
        title: 'Improve targeting',
        description: (
          <>
            <span>InvestorSet</span> provides ongoing connectivity to current and former holders of securities
            you arranged, better positioning you for ongoing support of your issuers in the secondary market.
          </>
        ),
      },
      {
        key: 'tradeMore',
        title: 'Trade more',
        description: (
          <>
            <span>InvestorSet</span> improves the industry’s overall access to information, shortening the education
            process and improving ability to participate in off-the-run names.
          </>
        ),
      },
    ],
  },
  corporateIssuers: {
    title: 'Corporate Issuers',
    logo: corporateIssuersLogo.src,
    benefits: [
      {
        key: 'broadenAwareness',
        title: 'Broaden awareness',
        description: (
          <>
            <span>InvestorSet</span> makes it easy for investors to explore new issuers and deals they are less
            familiar with. This can reduce friction in trading and during your next new issue process.
          </>
        ),
      },
      {
        key: 'improveVisibility',
        title: 'Improve visibility',
        description: (
          <>
            <span>InvestorSet</span> provides granular analytics on investor engagement. Enabling you to understand
            current, former and prospective investors across all your transactions in one place.
          </>
        ),
      },
      {
        key: 'improveLiquidity',
        title: 'Improve liquidity',
        description: (
          <>
            <span>InvestorSet</span> enables dealers and investors to quickly align on the latest terms and
            transaction docs, bypassing nuanced compliance requirements and enabling them to effect a transaction
            faster.
          </>
        ),
      },
    ],
  },
};
